require('jquery-match-height');

$(function() {
  $('[data-mh="product-name"]').matchHeight({
    byRow: false
  });
});